import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73')
];

export const server_loads = [];

export const dictionary = {
		"/": [7],
		"/(app)/attendees/[attendeeId]": [8,[2,3]],
		"/(app)/attendees/[attendeeId]/leads": [9,[2,3]],
		"/(app)/attendees/[attendeeId]/planner-input": [10,[2,3]],
		"/(app)/attendees/[attendeeId]/planner-results": [11,[2,3]],
		"/(app)/attendees/[attendeeId]/scan": [12,[2,3]],
		"/(app)/attendees/[attendeeId]/update-profile": [13,[2,3]],
		"/demo": [35,[6]],
		"/demo/dashboard": [36,[6]],
		"/demo/dashboard/attendee": [38,[6]],
		"/demo/dashboard/attendee/exhibitor/[exhibitorId]": [40,[6]],
		"/demo/dashboard/attendee/leads": [41,[6]],
		"/demo/dashboard/attendee/scan": [42,[6]],
		"/demo/dashboard/attendee/scan/[bookingEventId]": [43,[6]],
		"/demo/dashboard/attendee/update-profile": [44,[6]],
		"/demo/dashboard/attendee/[exhibitionId]": [39,[6]],
		"/demo/dashboard/event-organisers": [45,[6]],
		"/demo/dashboard/event-organisers/analytics": [49,[6]],
		"/demo/dashboard/event-organisers/create-event": [50,[6]],
		"/demo/dashboard/event-organisers/scan": [51,[6]],
		"/demo/dashboard/event-organisers/update-profile": [52,[6]],
		"/demo/dashboard/event-organisers/[exhibitionId]": [46,[6]],
		"/demo/dashboard/event-organisers/[exhibitionId]/create-talkshow": [47,[6]],
		"/demo/dashboard/event-organisers/[exhibitionId]/edit": [48,[6]],
		"/demo/dashboard/exhibitions": [53,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]": [54,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/attendees": [55,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/exhibitors-manager": [56,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/register": [57,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/talkshows": [58,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/talkshows/upsert": [59,[6]],
		"/demo/dashboard/exhibitions/[exhibitionId]/upsert": [60,[6]],
		"/demo/dashboard/exhibitor": [61,[6]],
		"/demo/dashboard/exhibitor/leads": [63,[6]],
		"/demo/dashboard/exhibitor/scan": [64,[6]],
		"/demo/dashboard/exhibitor/update-profile": [65,[6]],
		"/demo/dashboard/exhibitor/[exhibitorId]": [62,[6]],
		"/demo/dashboard/[role]": [37,[6]],
		"/demo/exhibitors/[exhibitorId]": [66,[6]],
		"/demo/login": [67,[6]],
		"/demo/planner-input": [68,[6]],
		"/demo/planner-results": [69,[6]],
		"/(app)/event-organisers/[eventOrganiserId]": [14,[2,4]],
		"/(app)/event-organisers/[eventOrganiserId]/analytics": [15,[2,4]],
		"/(app)/event-organisers/[eventOrganiserId]/scan": [16,[2,4]],
		"/(app)/event-organisers/[eventOrganiserId]/update-profile": [17,[2,4]],
		"/(app)/exhibitions": [18,[2]],
		"/(app)/exhibitions/[exhibitionId]": [19,[2]],
		"/(app)/exhibitions/[exhibitionId]/attendees": [20,[2]],
		"/(app)/exhibitions/[exhibitionId]/exhibitors-manager": [23,[2]],
		"/(app)/exhibitions/[exhibitionId]/exhibitors": [21,[2]],
		"/(app)/exhibitions/[exhibitionId]/exhibitors/[exhibitorId]": [22,[2]],
		"/(app)/exhibitions/[exhibitionId]/register": [24,[2]],
		"/(app)/exhibitions/[exhibitionId]/talkshows": [25,[2]],
		"/(app)/exhibitions/[exhibitionId]/talkshows/upsert/[[talkShowId]]": [26,[2]],
		"/(app)/exhibitions/[exhibitionId]/upsert": [27,[2]],
		"/(app)/exhibitors/[exhibitorId]": [28,[2,5]],
		"/(app)/exhibitors/[exhibitorId]/leads": [29,[2,5]],
		"/(app)/exhibitors/[exhibitorId]/scan": [30,[2,5]],
		"/(app)/exhibitors/[exhibitorId]/update-profile": [31,[2,5]],
		"/healthcheck": [70],
		"/login": [71],
		"/login/[role]": [72],
		"/login/[role]/callback": [73],
		"/(app)/onboarding/attendee/[attendeeId]": [32,[2]],
		"/(app)/onboarding/event-organiser/[eventOrganiserId]": [33,[2]],
		"/(app)/onboarding/exhibitor/[exhibitorId]": [34,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';